import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { OfflineShellModule } from './app/offline-shell.module';
import { environment } from './environments/environment';

// Basic connectivity probe: attempt to reach backend quickly with HEAD; fallback immediately if unreachable.
function probeBackend(url: string, timeoutMs: number): Promise<boolean>
{
	const controller = new AbortController();
	const timeout = setTimeout(() => controller.abort(), timeoutMs);

	// Normalize URL whether base ends with '/' or not using URL API
	const endpoint = new URL('api/abp/application-configuration?includeLocalizationResources=false', url).toString();
	return fetch(endpoint, {
		method: 'GET',
		signal: controller.signal,
	})
		.then(r => { clearTimeout(timeout); return r.ok; })
		.catch(() => { clearTimeout(timeout); return false; });
}

(async () =>
{
	const backendOk = navigator.onLine && await probeBackend(environment.apis.default.url, 30000);
	if (!backendOk)
	{
		console.warn('[bootstrap] Backend unreachable, bootstrapping OfflineShellModule');
		platformBrowserDynamic().bootstrapModule(OfflineShellModule)
			.catch(err => console.error('[bootstrap] Offline shell error', err));
	} else
	{
		platformBrowserDynamic().bootstrapModule(AppModule)
			.catch(err => console.error('[bootstrap] AppModule error', err));
	}
})();
